
/**
 * 신고 사유
 */
export type ReportCourseBodyReason = typeof ReportCourseBodyReason[keyof typeof ReportCourseBodyReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportCourseBodyReason = {
  SPAM: 'SPAM',
  INAPPROPRIATE_CONTENT: 'INAPPROPRIATE_CONTENT',
  COPYRIGHT_VIOLATION: 'COPYRIGHT_VIOLATION',
  MISLEADING_INFO: 'MISLEADING_INFO',
  HARASSMENT: 'HARASSMENT',
  OTHER: 'OTHER',
} as const;
